/*SYSTEM IMPORTS*/
import React from 'react'
import c from 'classnames'

import './style'
import './media'

/*Ui*/

/*Images*/

const Specialty = props => (
    <div className={c("specialty", props.className)}>
        {props.children}
    </div>
) 

const SpecialtyItem = props => (
    <div className={c("specialty__item", props.className)}>
        {props.value}
    </div>
) 

export { SpecialtyItem } 
export default Specialty